var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / water") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Awards-&-Illustrations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-water"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 19.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.05419333,17.0287624 C2.42546157,20.1700532 5.93045108,22.4037772 10.0378595,22.4037772 C12.3654634,22.4037772 14.4996118,21.686459 16.1616385,20.4931565 L16.1704453,20.4950432 C18.4862588,19.0567175 19.7603749,17.2008514 19.9927937,14.927445 C20.1225027,13.6586955 19.8361113,12.0424003 19.144811,10.795585 C18.2956305,9.26401992 17.1039306,8.1226384 16.9404529,7.97190203 C14.4710451,5.69495782 14.0504296,5.54403028 13.5256464,4.39334416 C13.2631703,3.81781581 13.1980501,3.32156456 13.1416242,2.74427284 C13.0834043,2.14862667 13.2668433,1.23386906 13.6919414,0 C11.3645073,0.896165494 9.75030351,1.58304274 8.84933002,2.06063175 C6.72806856,3.18507232 5.27339897,4.42432078 4.26964139,5.30724166 C3.24945502,6.20461356 1.85835884,7.46985598 1.14031731,8.92164874 C0.918439545,9.37025862 -0.0447962674,10.727289 0.00162250631,13.1416839 C0.0272265291,14.4734344 0.378083472,15.7691272 1.05419333,17.0287624 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "award---sorounding-icon",
    transform: "translate(12.000000, 12.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    rx: 8
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/Water.d2f7cd795a44a9e5a2adbed8b5aecf9c.svg";
export { ForwardRef as ReactComponent };